<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <h5 class="text-left">Modifier !</h5>

          <form v-on:submit.prevent class="remplacant-form">
            <div class="form-group row">
              <label for="salutation" class="col-sm-2 control-label"
                >Salutation</label
              >
              <div class="col-sm-5">
                <select
                  class="form-control"
                  v-on:change="sourceSalutationSelect"
                >
                  <option :value="remplacantById.salutation">{{
                    remplacantById.salutation
                  }}</option>
                  <option>Monsieur</option>
                  <option>Madame</option>
                  <option>Docteur</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="nom" class="col-sm-2 control-label"> Nom</label>
              <div class="col-sm-5">
                <input
                  autofocus
                  required
                  :value="remplacantById.nom"
                  placeholder="Nom"
                  autocomplete="off"
                  class="form-control"
                  v-on:keyup.stop="updateField('nom', $event.target.value)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="prenom" class="col-sm-2 control-label">Prénom</label>
              <div class="col-sm-5">
                <input
                  :value="remplacantById.prenom"
                  class="form-control"
                  placeholder="Prénom"
                  autocomplete="off"
                  type="text"
                  v-on:keyup.stop="updateField('prenom', $event.target.value)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="adresse" class="col-sm-2 control-label"
                >Adresse</label
              >
              <div class="col-sm-5">
                <input
                  :value="remplacantById.adresse"
                  name="adresse"
                  type="text"
                  class="form-control"
                  placeholder="Adresse"
                  v-on:keyup.stop="updateField('adresse', $event.target.value)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-2 control-label"> Email</label>
              <div class="col-sm-5">
                <input
                  :value="remplacantById.email"
                  name="email"
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-on:keyup.stop="updateField('email', $event.target.value)"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="ordre" class="col-sm-2 control-label">
                Num. conseil de l'ordre</label
              >
              <div class="col-sm-5">
                <input
                  name="ordre"
                  type="text"
                  class="form-control"
                  placeholder="Num. conseil de l'ordre"
                  :value="remplacantById.ordre"
                  v-on:keyup.stop="updateField('ordre', $event.target.value)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="urssaf" class="col-sm-2 control-label"> URSSAF</label>
              <div class="col-sm-5">
                <input
                  name="urssaf"
                  type="text"
                  class="form-control"
                  placeholder="Num. URSSAF"
                  :value="remplacantById.urssaf"
                  v-on:keyup.stop="updateField('urssaf', $event.target.value)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="telephone" class="col-sm-2 control-label"
                >Telephone</label
              >
              <div class="col-sm-5">
                <input
                  name="telephone"
                  type="text"
                  class="form-control"
                  placeholder="Num. téléphone"
                  :value="remplacantById.telephone"
                  v-on:keyup.stop="
                    updateField('telephone', $event.target.value)
                  "
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label"> Autre assurance ?</label>
              <div class="col-sm-5">
                <select
                  v-on:change="sourceAutreAssurance"
                  name="autre_assurance"
                  type="text"
                  class="form-control"
                >
                  <option :value="remplacantById.autreAssurance">{{
                    remplacantById.autreAssurance === true ? "Oui" : "Non"
                  }}</option>
                  <option value="true"> Oui</option>
                  <option value="false"> Non</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="typeContrat" class="col-sm-2 control-label"
                >Type de Contrat</label
              >
              <div class="col-sm-5">
                <select class="form-control" v-on:change="sourceContratSelect">
                  <option :value="remplacantById.typeContrat">{{
                    remplacantById.typeContrat
                  }}</option>
                  <option>Médecin</option>
                  <option>Etudiant</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="lieuNaiss" class="col-sm-2 control-label"
                >Lieu de naissance</label
              >
              <div class="col-sm-5">
                <input
                  name="lieuNaiss"
                  type="text"
                  class="form-control"
                  placeholder="Lieu de naissance"
                  :value="remplacantById.lieuNaiss"
                  v-on:keyup.stop="
                    updateField('lieuNaiss', $event.target.value)
                  "
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 control-label" for="dateNaiss">
                Date de naissance</label
              >
              <div class="col-7">
                <input
                  placeholder="Date de naissance"
                  :value="remplacantById.dateNaiss"
                  v-on:keyup.stop="
                    updateField('dateNaiss', $event.target.value)
                  "
                  name="date_naiss"
                  type="date"
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="actif" class="col-sm-2 control-label">Actif ?</label>
              <div class="col-sm-5">
                <select class="form-control" v-on:change="sourceActifSelect">
                  <option :value="remplacantById.actif">{{
                    remplacantById.actif ? "Oui" : "Non"
                  }}</option>
                  <option>{{ !remplacantById.actif ? "Oui" : "Non" }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <button
                class="btn btn-primary"
                type="submit"
                @click="updateRemplacant"
              >
                Valider
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import AppNav from "./AppNav";
import {
  UPDATE_REMPLACANT,
  REMPLACANT_BY_ID_QUERY
} from "../constants/graphql";

const pageSize = 10;

export default {
  name: "remplacants-edit",
  components: {
    AppNav
  },
  data() {
    return {
      remplacantById: {},
      nom: "",
      prenom: "",
      adresse: "",
      email: "",
      ordre: "",
      telephone: "",
      typeContrat: "",
      salutation: "",
      lieuNaiss: "",
      actif: null,
      autreAssurance: "",
      urssaf: "",
      dateNaiss: ""
    };
  },
  apollo: {
    remplacantById: {
      query: REMPLACANT_BY_ID_QUERY,
      variables() {
        var id = parseInt(this.$route.params.id, 10);
        return {
          id
        };
      }
    }
  },
  computed: {
    autreAssuranceComputed() {
      if (
        (this.remplacantById.autreAssurance === "" ||
          this.remplacantById.autreAssurance === false ||
          this.remplacantById.autreAssurance === true) &&
        this.autreAssurance === false
      ) {
        return false;
      } else if (
        (this.remplacantById.autreAssurance === "" ||
          this.remplacantById.autreAssurance === false ||
          this.remplacantById.autreAssurance === true) &&
        this.autreAssurance === true
      ) {
        return true;
      }
    }
  },
  methods: {
    sourceAutreAssurance(e) {
      this.autreAssurance = e.target.value === "true" ? true : false;
    },
    sourceActifSelect(e) {
      //TODO: I probably miss something in the dropbox
      this.actif =
        e.target.value === "Oui" || e.target.value === true ? true : false;
    },
    sourceContratSelect(e) {
      this.typeContrat = e.target.value;
    },
    sourceSalutationSelect(e) {
      this.salutation = e.target.value;
    },
    updateField(field, value) {
      this[field] = value;
    },
    updateRemplacant() {
      const nom = this.nom == "" ? this.remplacantById.nom : this.nom;
      const prenom =
        this.prenom == "" ? this.remplacantById.prenom : this.prenom;
      const adresse =
        this.adresse == "" ? this.remplacantById.adresse : this.adresse;
      const email = this.email == "" ? this.remplacantById.email : this.email;
      const ordre = this.ordre == "" ? this.remplacantById.ordre : this.ordre;
      const urssaf =
        this.urssaf == "" ? this.remplacantById.urssaf : this.urssaf;
      const telephone =
        this.telephone == "" ? this.remplacantById.telephone : this.telephone;
      const typeContrat =
        this.typeContrat == ""
          ? this.remplacantById.typeContrat
          : this.typeContrat;
      const salutation =
        this.salutation == ""
          ? this.remplacantById.salutation
          : this.salutation;
      const lieuNaiss =
        this.lieuNaiss == "" ? this.remplacantById.lieuNaiss : this.lieuNaiss;
      const dateNaiss =
        this.dateNaiss == "" ? this.remplacantById.dateNaiss : this.dateNaiss;
      const actif = _.isNull(this.actif)
        ? this.remplacantById.actif
        : this.actif;
      const autreAssurance = this.autreAssuranceComputed;
      console.log(this.autreAssurance, this.remplacantById.autreAssurance);
      this.$apollo
        .mutate({
          mutation: UPDATE_REMPLACANT,
          variables: {
            id: this.remplacantById.id,
            nom: nom,
            prenom: prenom,
            adresse: adresse,
            email: email,
            ordre: ordre,
            urssaf: urssaf,
            telephone: telephone,
            typeContrat: typeContrat,
            salutation: salutation,
            lieuNaiss: lieuNaiss,
            actif: actif,
            autreAssurance: autreAssurance,
            dateNaiss: dateNaiss
          }
        })
        .then(data => {
          router.push({
            name: "Remplacant",
            params: { id: this.remplacantById.id }
          });
        })
        .catch(error => {
          // Error
          console.error(error);
        });
    }
  }
};
</script>
<style scoped>
/* Move down content because we have a fixed navbar that is 3.5rem tall */

body {
  padding-top: 3.5rem;
}
/*
 * Typography
 */

h1 {
  margin-bottom: 20px;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}
/*
 * Sidebar
 */

.sidebar {
  position: fixed;
  top: 51px;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  /* Scrollable contents if viewport is shorter than content. */
  border-right: 1px solid #eee;
}

/* Sidebar navigation */

.sidebar {
  padding-left: 0;
  padding-right: 0;
}

.sidebar .nav {
  margin-bottom: 20px;
}

.sidebar .nav-item {
  width: 100%;
}

.sidebar .nav-item + .nav-item {
  margin-left: 0;
}

.sidebar .nav-link {
  border-radius: 0;
}

/*
 * Dashboard
 */

/* Placeholders */

.placeholders {
  padding-bottom: 3rem;
}

.placeholder img {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

select option[data-default] {
  display: none;
}

.medecins-form {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// remplacantsEdit.vue?859d7586